import { theme } from 'antd'
import { ThemeConfig } from 'antd/lib/config-provider/context'
import { darken, lighten } from 'polished'
import { createContext } from 'react'

export type ThemeCustomizationType = {
  primaryColor?: string
  backgroundColor?: string
  secondaryColor?: string
  dark?: boolean
  compact?: boolean
  colorBgBase?: string
}

export type ThemeContextValueType = {
  theme: ThemeConfig
  sideMenuTheme: ThemeConfig
  toolbarTheme: ThemeConfig
  customize?: (options: ThemeCustomizationType) => unknown
  customizeSideMenu?: (options: ThemeCustomizationType) => unknown
  customizeToolbar?: (options: ThemeCustomizationType) => unknown
}

export const ThemeContext = createContext<ThemeContextValueType>({
  sideMenuTheme: {},
  theme: {},
  toolbarTheme: {},
})

export const prepareTheme = (options: ThemeCustomizationType = {}): ThemeConfig => {
  if (!options.primaryColor) {
    options.primaryColor = '#EB6435'
  }
  if (!options.backgroundColor) {
    options.backgroundColor = '#fcfaf2'
  }

  if (!options.secondaryColor) {
    options.secondaryColor = 'rgba(0,0,0,0.04)'
  }

  return ({
    algorithm: [
      options.dark && theme.darkAlgorithm,
      options.compact && theme.compactAlgorithm,
    ].filter(e => !!e),
    components: {
      Button: {
        colorPrimary: options.primaryColor,
      },
      Card: {
        fontWeightStrong: 500,
      },
      Layout: {
        colorBgLayout: options.backgroundColor,
      },
      Menu: {
        itemHoverBg: 'transparent',
        itemHoverColor: options.primaryColor,
      },
      Segmented: {
        colorBgLayout: options.dark
          ? 'rgba(255,255,255,.0.4)'
          : 'rgba(0,0,0,.04)'
        ,
      },
    },
    token: {
      borderRadius: 6,
      colorBgLayout: options.backgroundColor,
      colorFillSecondary: options.secondaryColor,
      colorLink: options.primaryColor,
      colorLinkActive: darken(0.1, options.primaryColor),
      colorLinkHover: lighten(0.1, options.primaryColor),
      colorPrimary: options.primaryColor,
      fontFamily: '"Basier Circle", sans-serif',
      fontSize: 16,
    },
  })
}

